var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path4, _path5, _polygon, _polygon2, _polygon3, _rect9, _rect10, _rect11, _rect12, _rect13, _polygon4, _polygon5, _polygon6, _rect14, _rect15, _rect16, _rect17, _rect18, _path6, _path7, _g, _path8, _polygon7, _polygon8, _polygon9, _polygon10, _path9, _polygon11, _polygon12, _polygon13, _polygon14, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g2, _path23, _path24, _polygon15, _rect19, _rect20, _rect21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgTechWorkshop5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 257 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-13,.cls-17,.cls-2,.cls-3{fill:#00ac71;}.cls-2,.cls-5{opacity:0.502;}.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill:#fff;}.cls-4{opacity:0.8;}.cls-7{opacity:0.302;}.cls-8{opacity:0.4;}.cls-9{fill:#fcb373;}.cls-10{clip-path:url(#clip-path);}.cls-11{isolation:isolate;}.cls-12{clip-path:url(#clip-path-2);}.cls-13{opacity:0.102;}.cls-14{opacity:0.2;}.cls-15{fill:#1a2e35;}.cls-16{fill:#007cff;}.cls-17{opacity:0.6;}.cls-18{clip-path:url(#clip-path-3);}.cls-19{clip-path:url(#clip-path-4);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.93591,80.73889,74.254,83.61182s8.09814-3.79175,9.853-6.00049c.44848-.57031,1.06884-1.47815,1.738-2.51355,1.10205-1.71033,2.34766-3.76966,3.21143-5.2146.6416-1.07947,1.07348-1.81555,1.07348-1.81555l-4.58325-7.23c-1.00219.76965-4.06933,13.12536-4.6167,13.78967C80.38147,75.29187,72.93591,80.73889,72.93591,80.73889Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.75,
    y: 60.75,
    width: 17.5,
    height: 23
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.69434,85.45776s3.22143-19.62353-2.31372-28.42151c0,0-11.05542-.68688-18.83374,3.802,0,0,3.21411,8.73694,3.69238,24.6195Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.5,
    y: 56.25,
    width: 24.5,
    height: 29.25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.06987,104.89462V34.307a3.65383,3.65383,0,0,1,3.65379-3.65381h64.27928a3.65381,3.65381,0,0,1,3.65381,3.65381v70.58763a3.65386,3.65386,0,0,1-3.65381,3.6538H122.72366a3.65378,3.65378,0,0,1-3.65379-3.6538Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.80945,103.38768V32.80005a3.65382,3.65382,0,0,1,3.65379-3.65381h64.27928a3.65383,3.65383,0,0,1,3.65381,3.65381v70.58763a3.65386,3.65386,0,0,1-3.65381,3.6538H120.46324a3.65378,3.65378,0,0,1-3.65379-3.6538Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.80945,103.38768V32.80005a3.65382,3.65382,0,0,1,3.65379-3.65381h64.27928a3.65383,3.65383,0,0,1,3.65381,3.65381v70.58763a3.65386,3.65386,0,0,1-3.65381,3.6538H120.46324a3.65378,3.65378,0,0,1-3.65379-3.6538Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.27148,
    y: 58.10144,
    width: 31.72386,
    height: 20.63337
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 147.27148,
    y: 58.10144,
    width: 31.72386,
    height: 20.63337
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 148.43213,
    y: 61.97015,
    width: 29.40263,
    height: 15.73298
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 150.82813,
    y: 64.32094,
    width: 21.74977,
    height: 0.6769
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 150.82813,
    y: 66.39377,
    width: 10.43546,
    height: 0.67682
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 150.82813,
    y: 68.4666,
    width: 13.14355,
    height: 0.67677
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 150.82813,
    y: 70.53943,
    width: 4.63229,
    height: 0.67677
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 150.82813,
    y: 72.61216,
    width: 2.99979,
    height: 0.67689
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.76221,88.14563V99.64978a1.29625,1.29625,0,0,1-1.10669,1.28491.9987.9987,0,0,1-.19458.0166H163.68188a1.30147,1.30147,0,0,1-1.30175-1.30151V88.14563a1.24278,1.24278,0,0,1,.13257-.56763,1.29736,1.29736,0,0,1,1.16918-.738h5.791a1.31288,1.31288,0,0,0,.76709-.24878,1.27155,1.27155,0,0,0,.4729-.64685,1.30382,1.30382,0,0,1,1.2395-.89954h3.084a1.30063,1.30063,0,0,1,1.2395.89954,1.30206,1.30206,0,0,0,1.2395.89563h.94556A1.30446,1.30446,0,0,1,179.76221,88.14563Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M178.65552,88.68921v12.24536l-.0166.0166h-14.957a1.30152,1.30152,0,0,1-1.30175-1.30176V88.14551a1.24167,1.24167,0,0,1,.13257-.56763h15.03149A1.11109,1.11109,0,0,1,178.65552,88.68921Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "147.468 31.574 147.468 45.962 144.657 48.772 134.349 48.772 134.349 31.574 147.468 31.574"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "147.468 31.574 147.468 45.962 144.657 48.772 134.349 48.772 134.349 31.574 147.468 31.574"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "147.467 45.962 144.657 45.962 144.657 48.772 147.467 45.962"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.98508,
    y: 34.49289,
    width: 9.89142,
    height: 0.53979
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.98508,
    y: 36.14578,
    width: 8.32141,
    height: 0.53969
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.98508,
    y: 37.79874,
    width: 9.89142,
    height: 0.53969
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.98508,
    y: 39.45161,
    width: 3.69389,
    height: 0.53969
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.98508,
    y: 41.10448,
    width: 2.39207,
    height: 0.53976
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "135.179 66.911 135.179 81.299 132.369 84.109 122.061 84.109 122.061 66.911 135.179 66.911"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "135.179 66.911 135.179 81.299 132.369 84.109 122.061 84.109 122.061 66.911 135.179 66.911"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "135.179 81.299 132.368 81.299 132.368 84.109 135.179 81.299"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.69662,
    y: 69.82999,
    width: 9.89142,
    height: 0.53979
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.69662,
    y: 71.48294,
    width: 8.32141,
    height: 0.53968
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.69662,
    y: 73.13586,
    width: 9.89142,
    height: 0.53968
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.69662,
    y: 74.78877,
    width: 3.69389,
    height: 0.53968
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.69662,
    y: 76.44164,
    width: 2.39208,
    height: 0.53976
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M76.0929,78.52722,70.204,83.31067s-1.44019.03-1.89282.50537c-.45264.47583-2.19141,4.01025-1.94385,4.49219.24731.48242,3.15308,1.43506,3.76587.86474a13.31724,13.31724,0,0,0,1.65552-4.18945l7.52612-5.04785Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.93591,80.73889,74.254,83.61182s8.09814-3.79175,9.853-6.00049c.44848-.57031,1.06884-1.47815,1.738-2.51355,1.10205-1.71033,2.34766-3.76966,3.21143-5.2146.6416-1.07947,1.07348-1.81555,1.07348-1.81555l-4.58325-7.23c-1.00219.76965-4.06933,13.12536-4.6167,13.78967C80.38147,75.29187,72.93591,80.73889,72.93591,80.73889Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M85.84534,75.09729c1.10156-1.71021,2.34741-3.76965,3.21118-5.21472L86.92468,64.624A62.71927,62.71927,0,0,0,85.84534,75.09729Z"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M123.18054,51.19983l5.80469-4.50574s.47046-1.36194,1.06128-1.6466c.59131-.28528,4.488-.85791,4.87158-.47535.38306.38318.40015,3.44141-.32983,3.8501a13.34353,13.34353,0,0,1-4.49585.2937l-6.34009,4.631Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "74.176 175.058 77.651 175.672 79.077 170.933 80.377 166.585 76.37 165.185 75.206 170.412 74.176 175.058"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "75.188 170.519 79.06 171.028 80.369 166.632 76.366 165.209 75.188 170.519"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "97.376 175.146 100.905 175.146 101.484 170.411 102.009 165.992 97.819 165.355 97.582 170.547 97.376 175.146"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "97.583 170.858 101.484 170.686 102.008 166.13 97.819 165.424 97.583 170.858"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M74.86072,166.71838l5.71216,1.00684c5.76513-14.36279,9.86523-26.35132,12.76123-36.30029,1.55957-5.36817,2.79541-10.14209,3.72924-14.37793l-.24023,15.63525v35.26709h5.7605c14.1123-66.98242,4.11059-82.55395,4.11059-82.55395L89.81262,82.57263a76.77287,76.77287,0,0,0-1.41382,9.47949l-.76147,5.59766-6.59985,34.08594Z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "81.469 167.019 74.383 164.67 74.479 167.684 80.339 169.553 81.469 167.019"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "81.469 167.019 74.383 164.67 74.479 167.684 80.339 169.553 81.469 167.019"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "103.341 167.347 95.954 166.266 96.573 169.217 102.669 170.039 103.341 167.347"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "103.341 167.347 95.954 166.266 96.573 169.217 102.669 170.039 103.341 167.347"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M92.55676,134.05444c.26587-.89233.54981-1.76855.8-2.62939,1.41382-4.87256,2.35913-9.25464,3.46631-13.18848v-.01025l.5769-7.24146s-3.61084-7.95605-2.25976-13.55371c-.12549.31836-2.51538,6.417-1.57593,12.51026A177.42458,177.42458,0,0,1,92.55676,134.05444Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92.07056,53.56946a.81732.81732,0,0,0,.14795.08056,6.19683,6.19683,0,0,0,2.30029.77649c2.35522.23059,3.87646-.28613,4.761-1.45361l.00512-.00049c1.22608-1.73755,1.22486-4.53406.59155-7.82336a12.544,12.544,0,0,0-1.228-3.77954c-.00684-.00965-.01172-.04834-.01856-.05738-.02588-.03894-.04883-.09484-.0747-.13342a4.56524,4.56524,0,0,0-3.686-2.33032,9.266,9.266,0,0,0-1.98975.03515C86.40454,39.65808,86.63379,50.52087,92.07056,53.56946Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M92.21851,53.6499a6.04562,6.04562,0,0,0,2.28784.68567c2.35571.23047,3.86743-.36084,4.74975-1.5437a6.49807,6.49807,0,0,1-4.14575.19763A3.39278,3.39278,0,0,0,92.21851,53.6499Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M91.73413,58.945c-.58154,1.80908,1.738,2.79712,1.738,2.79712,4.07934-1.28724,5.01025-3.29822,5.01025-3.29822-3.09888-2.02393-1.68042-6.74927-1.68042-6.74927l-.697.26184-4.75317.45447s1.05029,2.61023,1.166,3.19311c-.00073.00562.0044.01111.00391.01587C93.10864,58.66565,91.73413,58.945,91.73413,58.945Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M98.64539,41.32629a6.8551,6.8551,0,0,1-3.09766,6.99524S94.31628,53.273,91.608,53.69336c-3.69238.57214-7.64209-4.27319-7.0581-9.80737C85.308,36.70886,95.77966,34.77039,98.64539,41.32629Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M97.55542,46.73645c-.09375-.70752-.81714-1.82117-1.89551-1.51672-1.1167.31494-1.38257,3.20263,1.49658,3.46545C97.56934,48.7229,97.75024,48.2124,97.55542,46.73645Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M101.27783,174.47693h-3.938a.36.36,0,0,0-.35009.28174l-.8086,3.65185a.60295.60295,0,0,0,.6001.73c1.61206-.02588,1.74219-.12475,3.76587-.12475,1.24731,0,5.00879.13037,6.73047.13037s1.9458-1.70069,1.2417-1.85718c-3.16236-.68848-5.54077-1.64331-6.55274-2.55127A.9897.9897,0,0,0,101.27783,174.47693Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.84082,174.90967a1.99171,1.99171,0,0,0,1.46094-.07324.40122.40122,0,0,0,.13061-.34913c-.00537-.07885-.03662-.115-.06274-.115a.225.225,0,0,0-.12525-.02612A3.989,3.989,0,0,0,101.84082,174.90967Zm-.28125.1355a.09773.09773,0,0,1-.07324-.0835.08813.08813,0,0,1,.04663-.09326c.14624-.09448,1.47119-.9082,1.92529-.67334a.29254.29254,0,0,1,.16748.27124.57649.57649,0,0,1-.20385.52222,1.22867,1.22867,0,0,1-.78785.20825A4.898,4.898,0,0,1,101.55957,175.04517Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.19067,173.46985a2.30166,2.30166,0,0,0-.48535,1.28393c.4231-.31836.94434-1.00195.89234-1.26831-.00489-.02612-.01538-.09912-.14063-.09912h-.04687A.335.335,0,0,0,102.19067,173.46985Zm-.65747,1.59643a.1036.1036,0,0,1-.04663-.08862c.00489-.05737.104-1.23657.57935-1.62231a.51674.51674,0,0,1,.41162-.125.31792.31792,0,0,1,.31348.25512c.083.43335-.73609,1.3357-1.15894,1.56519h-.04663A.08713.08713,0,0,1,101.5332,175.06628Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M77.78662,174.47693H73.84814a.36.36,0,0,0-.34985.28174l-.80884,3.65185a.60317.60317,0,0,0,.60034.73c1.61207-.02588,1.742-.12475,3.76587-.12475,1.24707,0,5.00855.13037,6.73047.13037,1.72168,0,1.9458-1.70069,1.24146-1.85718-3.16138-.68848-5.54077-1.64331-6.55274-2.55127A.98893.98893,0,0,0,77.78662,174.47693Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.3501,174.90967a1.98989,1.98989,0,0,0,1.4602-.07324.3999.3999,0,0,0,.13062-.34913c-.00488-.07885-.03662-.115-.0625-.115a.2259.2259,0,0,0-.12525-.02612A3.981,3.981,0,0,0,78.3501,174.90967Zm-.28174.1355a.09773.09773,0,0,1-.07324-.0835.08745.08745,0,0,1,.04712-.09326c.1455-.09448,1.4707-.9082,1.9248-.67334a.29211.29211,0,0,1,.167.27124.57413.57413,0,0,1-.20385.52222,1.22672,1.22672,0,0,1-.78785.20825A4.89577,4.89577,0,0,1,78.06836,175.04517Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.6991,173.46985a2.29935,2.29935,0,0,0-.48487,1.28393c.42237-.31836.94385-1.00195.89185-1.26831-.00488-.02612-.01538-.09912-.14038-.09912h-.04712A.335.335,0,0,0,78.6991,173.46985Zm-.657,1.59643a.10288.10288,0,0,1-.04711-.08862c.00512-.05737.10424-1.23657.57885-1.62231a.51836.51836,0,0,1,.41211-.125.31771.31771,0,0,1,.31348.25512c.08325.43335-.73609,1.3357-1.1582,1.56519h-.04712A.08693.08693,0,0,1,78.04211,175.06628Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.69434,85.45776s3.22143-19.62353-2.31372-28.42151c0,0-11.05542-.68688-18.83374,3.802,0,0,3.21411,8.73694,3.69238,24.6195Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M107.70349,70.44019c.23779-2.66272-.53247-5.22583-.665-7.48426a21.73338,21.73338,0,0,1-3.6394-4.14929S102.39246,66.75647,107.70349,70.44019Z"
  }))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.01111,56.99854s10.95605-1.28406,12.60376-1.97571c1.03222-.43274,9.08471-5.69519,9.08471-5.69519L126.588,52.1394s-8.24,6.65393-9.63232,7.41858a96.30618,96.30618,0,0,1-10.60864,4.32508S101.91174,60.79993,103.01111,56.99854Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M98.48242,44.29773s4.55347-4.55347.259-7.619c-4.29419-3.06653-8.61158.93359-8.61158.93359s-10.27856,2.4823-8.09057,9.315c2.18823,6.83288,3.61767,7.41455.36328,10.91992-3.25391,3.50451-6.58155,8.69653-3.25391,12.01355,3.32715,3.31714,14.95532-.09558,18.48486-5.105C101.16333,59.746,94.92505,48.99719,98.48242,44.29773Z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.239 85.458 89.17 83.597 106.897 84.047 106.897 85.768 89.239 85.458"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 94.14555,
    y: 83.72292,
    width: 0.71383,
    height: 1.8335
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 102.4122,
    y: 83.93274,
    width: 0.63068,
    height: 2.00145
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 89.65675,
    y: 83.62425,
    width: 0.60273,
    height: 2.14361
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTechWorkshop5);
export default __webpack_public_path__ + "static/media/img_tech_workshop5.a9ba6d48c3b642d90e88727af98a4738.svg";
export { ForwardRef as ReactComponent };